import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage.service';
import { inject } from '@angular/core';

export const referralGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  // Check if user has joined
  const isJoined = localStorageService.getDataByKey('is_subscriber');

  if (isJoined) {
    return true;
  } else {
    return router.createUrlTree(['/']);
  }
};
